import React from 'react';
import { $MaintenanceNotice, $ImgContainer } from './styles';
import notFound from '../assets/icons/notFound.svg';
import { Title } from '../';
export const NotFound404 = ({ message = 'The page you’re looking for couldn’t be found' }) => (React.createElement($MaintenanceNotice, null,
    React.createElement($ImgContainer, null,
        React.createElement("img", { src: notFound, alt: 'resource not found' })),
    React.createElement(Title, { alternate: true }, message)));
